<script>
export default {
    name: 'PortraitSection',
    data: () => {
        return {
            windowWidth: 0,
            windowHeight: 0,
            currentScrollY: 0,
            currentProgress: 0,
        }
    },
    mounted() {
        this.setWindowHeight();
        this.onScroll();
        window.addEventListener('scroll', (e) => this.onScroll(e));
        window.addEventListener('resize', () => this.setWindowHeight());
    },
    methods: {
        onScroll() {
            this.currentScrollY = window.pageYOffset;
            this.currentProgress = (window.pageYOffset / window.innerHeight) <= 1 ? window.pageYOffset / window.innerHeight : 1;
        },
        isInView() {
            return this.currentScrollY > window.innerHeight * .15;
        },
        setWindowHeight() {
            this.windowHeight = window.innerHeight;
            this.windowWidth = window.innerWidth;
        },
    },
};
</script>

<template>
    <section class="portrait">
        <div class="portrait__content">
            <article class="portrait__article" v-bind:class="{'portrait__article--in-view': isInView()}">
                <h1 class="portrait__article__title">{{ $t('portrait.row1.title') }}</h1>
                <p class="portrait__article__paragraph" v-html="$t('portrait.row1.text')"></p>
            </article>
            <article class="portrait__article" v-bind:class="{'portrait__article--in-view': isInView()}">
                <h1 class="portrait__article__title">{{ $t('portrait.row2.title') }}</h1>
                <p class="portrait__article__paragraph" v-html="$t('portrait.row2.text')"></p>
            </article>
            <article class="portrait__article" v-bind:class="{'portrait__article--in-view': isInView()}">
                <h1 class="portrait__article__title">{{ $t('portrait.row3.title') }}</h1>
                <p class="portrait__article__paragraph" v-html="$t('portrait.row3.text')"></p>
            </article>
        </div>
    </section>
</template>

<style lang="scss" scoped>
@import '../styles/variables';
.portrait {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 48rem;
    z-index: 4;

    @media (max-width: 960px) {
        height: auto;
    }
}
.portrait__content {
    display: flex;
    width: 55.6875rem;
    margin: 0 auto;
    transform-origin: top;
    transform: translateY(-12rem);

    @media (max-width: 960px) {
        display: block;
        width: 100%;
        margin: 0 1.5rem;
        transform: translateY(0);
    }
}
.portrait__article {
    position: relative;
    box-sizing: border-box;
    width: 17.1875rem;
    height: 32.8rem;
    margin: 0 0.6875rem;
    padding: 1.2rem 0.78125rem;
    font-size: 1.125rem;
    line-height: 1.27;
    color: $color-light;
    background: rgba($color-light, 0);
    transition: background 200ms linear;

    @media (max-width: 960px) {
        width: 100%;
        max-width: 19rem;
        height: auto;
        min-height: 30rem;
        margin: 6rem auto;
        color: $color-primary;
        background: rgba($color-light, 255);
    }
}
.portrait__article--in-view {
    color: $color-primary;
    background: rgba($color-light, 255);
}
.portrait__article:before {
    content: "";
    position: absolute;
    top: -1.5rem; right: .75rem;
    width: 8.8125rem;
    height: .3125rem;
    background: $color-light;
}
.portrait__article__title {
    margin: 0 0 1rem;
    font-size: 1.125rem;
    line-height: 1.222;
    text-transform: uppercase;
    font-weight: normal;
}
.portrait__article__paragraph {
    color: $color-primary;
    margin: 0 0 1.5rem;
}
.portrait__article__list {
    margin: 0;
    padding: 0;
}
.portrait__article__list-item {
    list-style: none;
    margin: .2rem 0;
}
.portrait__article-link {
    color: $color-primary;
}
</style>
